const X_SHARE_BASE_URL = "https://twitter.com/intent/tweet";

export function buildXShareUrl(params: { text: string; url?: string }): string {
  const query = new URLSearchParams({ text: params.text });
  if (params.url !== undefined) {
    query.set("url", params.url);
  }
  return `${X_SHARE_BASE_URL}?${query.toString()}`;
}
